import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ upper: 5 }]],
      [RiskLevel.Medium, [{ lower: 5, upper: 15 }]],
      [RiskLevel.High, [{ lower: 15, upper: 100 }]],
    ]),
  ],
]);

export default referenceRange;
